// module.exports = {
//   development: {
//     USERCENTER: 'http://dev.api.b2bcsx.com:8000/ucenter/',
//     USERCENTERDEV: 'http://dev.api.b2bcsx.com:8000/ucenter-dev/',
//     SUPPLIER: 'http://dev.api.b2bcsx.com:8000/scc/', // 测试环境
//     CAISX_SETTLE: 'http://dev.api.b2bcsx.com:8000/gss/',
//     TASKCENTER: 'http://dev.api.b2bcsx.com:8000/', //任务中心获取消息列表接口
//     MESSAGECENTER: 'http://dev.api.b2bcsx.com:8000/message/', // 获取消息中心的websocket地址
//     DEVOPS: 'https://wapi.freshfood.cn/',
//     CAISX_MDM: 'http://dev.api.b2bcsx.com:8000/mdm/',
//     SCM: 'http://dev.api.b2bcsx.com:8000/scm/',
//     MALIANG: 'http://dev.api.b2bcsx.com:8000/maliang1/',
//     NOT: 'http://dev.api.b2bcsx.com:8000/',
//   },
//   dev: {
//     USERCENTER: 'http://dev.api.b2bcsx.com:8000/ucenter/',
//     USERCENTERDEV: 'http://dev.api.b2bcsx.com:8000/ucenter-dev/',
//     SUPPLIER: 'http://dev.api.b2bcsx.com:8000/scc/', // 测试环境
//     CAISX_SETTLE: 'http://dev.api.b2bcsx.com:8000/gss/',
//     TASKCENTER: 'http://dev.api.b2bcsx.com:8000/', //任务中心获取消息列表接口
//     MESSAGECENTER: 'http://dev.api.b2bcsx.com:8000/message/', // 获取消息中心的websocket地址
//     DEVOPS: 'https://wapi.freshfood.cn/',
//     CAISX_MDM: 'http://dev.api.b2bcsx.com:8000/mdm/',
//     SCM: 'http://dev.api.b2bcsx.com:8000/scm/',
//     MALIANG: 'http://dev.api.b2bcsx.com:8000/maliang1/',
//     NOT: 'http://dev.api.b2bcsx.com:8000/',
//   },
//   test: {
//     USERCENTER: 'http://dev.api.b2bcsx.com:8000/ucenter/',
//     USERCENTERDEV: 'http://dev.api.b2bcsx.com:8000/ucenter-dev/',
//     SUPPLIER: 'http://dev.api.b2bcsx.com:8000/scc/',
//     CAISX_SETTLE: 'http://dev.api.b2bcsx.com:8000/gss/',
//     TASKCENTER: 'http://dev.api.b2bcsx.com:8000/', //任务中心获取消息列表接口
//     MESSAGECENTER: 'http://dev.api.b2bcsx.com:8000/message/', // 获取消息中心的websocket地址
//     DEVOPS: 'https://wapi.freshfood.cn/',
//     CAISX_MDM: 'http://dev.api.b2bcsx.com:8000/mdm/',
//     SCM: 'http://dev.api.b2bcsx.com:8000/scm/',
//     MALIANG: 'http://dev.api.b2bcsx.com:8000/maliang1/',
//     NOT: 'http://dev.api.b2bcsx.com:8000/',
//   },
//   pre: {
//     USERCENTER: 'http://pre.api.b2bcsx.com/ucenter/',
//     USERCENTERDEV: 'http://pre.api.b2bcsx.com/ucenter/',
//     SUPPLIER: 'http://pre.api.b2bcsx.com/scc/',
//     CAISX_SETTLE: 'http://pre.api.b2bcsx.com/gss/',
//     TASKCENTER: 'http://pre.api.b2bcsx.com/',
//     MESSAGECENTER: 'http://pre.api.b2bcsx.com/message/',
//     DEVOPS: 'https://wapi.freshfood.cn/',
//     CAISX_MDM: 'http://pre.api.b2bcsx.com/mdm/',
//     SCM: 'http://pre.api.b2bcsx.com/scm/',
//     MALIANG: 'http://pre.api.b2bcsx.com/maliang1/',
//     NOT: 'http://pre.api.b2bcsx.com/',
//   },
//   sit: {
//     USERCENTER: 'http://sit.api.b2bcsx.com/ucenter/',
//     USERCENTERDEV: 'http://sit.api.b2bcsx.com/ucenter/',
//     SUPPLIER: 'http://sit.api.b2bcsx.com/scc/',
//     CAISX_SETTLE: 'http://sit.api.b2bcsx.com/gss/',
//     TASKCENTER: 'http://sit.api.b2bcsx.com/',
//     MESSAGECENTER: 'http://sit.api.b2bcsx.com/message/',
//     DEVOPS: 'https://wapi.freshfood.cn/',
//     CAISX_MDM: 'http://sit.api.b2bcsx.com/mdm/',
//     SCM: 'http://sit.api.b2bcsx.com/scm/',
//     MALIANG: 'http://sit.api.b2bcsx.com/maliang1/',
//     NOT: 'http://sit.api.b2bcsx.com/',
//   },
//   production: {
//     USERCENTER: 'https://wapi.freshfood.cn/ucenter/',
//     USERCENTERDEV: 'https://wapi.freshfood.cn/ucenter/',
//     SUPPLIER: 'https://wapi.freshfood.cn/scc/',
//     CAISX_SETTLE: 'https://wapi.freshfood.cn/gss/',
//     TASKCENTER: 'https://wapi.freshfood.cn/',
//     MESSAGECENTER: 'https://wapi.freshfood.cn/message/',
//     DEVOPS: 'https://wapi.freshfood.cn/',
//     CAISX_MDM: 'https://wapi.freshfood.cn/mdm/',
//     SCM: 'https://wapi.freshfood.cn/scm/',
//     MALIANG: 'https://wapi.freshfood.cn/maliang1/',
//     NOT: 'https://wapi.freshfood.cn/',
//   },
// }[process.env.NODE_ENV];

import { NEW_GATEWAY } from './enum';
// DEVOPS_SWITCH_HOST 特性开关host
import { reduce } from 'lodash';

//     USERCENTER: 'http://dev.api.b2bcsx.com:8000/ucenter/',
//     USERCENTERDEV: 'http://dev.api.b2bcsx.com:8000/ucenter-dev/',
//     SUPPLIER: 'http://dev.api.b2bcsx.com:8000/scc/', // 测试环境
//     CAISX_SETTLE: 'http://dev.api.b2bcsx.com:8000/gss/',
//     TASKCENTER: 'http://dev.api.b2bcsx.com:8000/', //任务中心获取消息列表接口
//     MESSAGECENTER: 'http://dev.api.b2bcsx.com:8000/message/', // 获取消息中心的websocket地址
//     DEVOPS: 'https://wapi.freshfood.cn/',
//     CAISX_MDM: 'http://dev.api.b2bcsx.com:8000/mdm/',
//     SCM: 'http://dev.api.b2bcsx.com:8000/scm/',
//     MALIANG: 'http://dev.api.b2bcsx.com:8000/maliang1/',
//     NOT: 'http://dev.api.b2bcsx.com:8000/',
const HostMap = {
  USERCENTER: '/ucenter/',
  USERCENTERDEV: '/ucenter-dev/',
  SUPPLIER: '/scc/',
  CAISX_SETTLE: '/gss/',
  TASKCENTER: '/',
  MESSAGECENTER: '/',
  DEVOPS: '/',
  CAISX_MDM: '/mdm/',
  SCM: '/scm/',
  MALIANG: '/maliang1/',
  NOT: '/',
  SYSTEM: '/system/',
  FQS: '/fqs/',
  FQSAPP: '/fqs-app/',
};
console.log(11111, process.env.CSX_FE_SCC_DEVOPS_HOST_TEST, process.env.CSX_FE_PUBLIC_DEVOPS_HOST);
const hostWapi = process.env.CSX_FE_SCC_DEVOPS_HOST_TEST || 'https://wapi.freshfood.cn';
const getBaseUrl = function () {
  return reduce(
    HostMap,
    (prev, val, key) => {
      //
      if (key === 'DEVOPS') {
        return { ...prev, [key]: hostWapi + val };
      }

      return { ...prev, [key]: process.env.CSX_FE_PUBLIC_WAPI_HOST + val };
    },
    {},
  );
};

export default getBaseUrl();
